/* eslint-disable id-match */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { BOOKING_CALENDAR_NIGHTS } from '../../../../brands/default/content/components/deal';
import CustomNativeSelect from '../../../_generic/custom-native-select/CustomNativeSelect';

const BookingCalendarNights = ({ deal, onNightChange }) => {
  const [nights, setNights] = useState(null);
  const [selectedValue, setSelectedValue] = useState('');
  const { cyfBookingStepThree } = BOOKING_CALENDAR_NIGHTS;

  const onChange = (event) => {
    setSelectedValue(event.target.value);
    onNightChange(event.target.value);
  };

  useEffect(() => {
    if (nights && nights.length > 0) {
      setSelectedValue(nights[0].header);
      onNightChange(nights[0].header);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nights]);

  useEffect(() => {
    if (deal.productDisplay.column && deal.productDisplay.column.items) {
      setNights(deal.productDisplay.column.items);
    }
  }, [deal]);

  return (
    nights && (
      <>
        <CustomNativeSelect
          ariaLabel={cyfBookingStepThree}
          /* eslint-disable-next-line react/forbid-component-props */
          className="full-width margin"
          id="num-nights"
          onChange={onChange}
          value={selectedValue}
        >
          {nights.map((night) => {
            return (
              <option key={night.id} value={night.header}>
                {night.header}
              </option>
            );
          })}
        </CustomNativeSelect>
      </>
    )
  );
};

BookingCalendarNights.propTypes = {
  deal: PropTypes.object.isRequired,
  onNightChange: PropTypes.func.isRequired,
};

export default BookingCalendarNights;
